import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Form } from "react-bootstrap";
import { Switch, Tooltip } from "@mui/material";
import { getHistorialActasInspector } from "./handlers";
import { formatRangeString } from "../Recibos/handlers";
import HelperText from "../../components/HelperText";
import PulseOpacitySpinner from "../../components/MuniSpinner/PulseOpacitySpinner";
import MapaDeCalor from "../../components/MapaDeCalor";
import InfoIcon from "@mui/icons-material/Info";

const BusquedaMapaCalor = (props) => {
  const [historialActasInspector, setHistorialActasInspector] = useState(null);
  const [historialCoordenadasInspector, setHistorialCoordenadasInspector] = useState(null);
  const [textoRango, setTextoRango] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { selectedRow } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      user_id_inspector: selectedRow.id,
      fecha_ini: "",
      fecha_fin: "",
    },
  });

  useEffect(() => {
    let today = new Date();
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, "0");
    let day = String(today.getDate()).padStart(2, "0");
    let formattedDate = year + "-" + month + "-" + day;

    setValue("fecha_ini", formattedDate);
    setValue("fecha_fin", formattedDate);

    getHistorialActasInspector(getValues(), setHistorialActasInspector, setHistorialCoordenadasInspector, setTextoRango, setError, setIsLoading);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {isLoading ? (
        <PulseOpacitySpinner />
      ) : (
        <>
          {historialActasInspector && (
            <>
              <h5>Total de actas {textoRango}</h5>
            </>
          )}
          {historialCoordenadasInspector && (
            <div className='position-relative'>
              <div className='position-absolute container_menu d-flex align-items-center' style={{ top: "0px", right: "0px", zIndex: "9999", borderTopRightRadius: "0.375rem", borderBottomLeftRadius: "0.375rem", backgroundColor: "#f4f4f4" }}>
                <Switch data-bs-toggle='collapse' data-bs-target='#seleccionRangoFechas' aria-expanded='false' aria-controls='seleccionRangoFechas' />
                <p className='mb-0 me-2'>Seleccionar un rango de fechas</p>
              </div>
              <div className='pt-2 px-5 w-100 container_menu position-absolute collapse bottom-0 right-0' style={{ zIndex: "999", backgroundColor: "#fff" }} id='seleccionRangoFechas'>
                <Form className='mb-2' onSubmit={handleSubmit((data) => getHistorialActasInspector(data, setHistorialActasInspector, setHistorialCoordenadasInspector, setTextoRango, setError, setIsLoading))}>
                  <fieldset className='d-flex gap-2 gap-sm-4 align-items-end flex-wrap'>
                    <div className='relative d-none'>
                      <label className='mb-2'>Documento del inspector</label>
                      <input className='form-control' type='number' {...register("user_id_inspector")} value={selectedRow.id} />
                      <p className='absolute bottom-0 text-danger' style={{ fontSize: "15px", marginBottom: "0px" }}>
                        {errors?.documento_inspector?.message}
                      </p>
                    </div>
                    <div className='relative'>
                      <label className='mb-2'>Fecha de inicio</label>
                      <input className='form-control' type='date' {...register("fecha_ini")} />
                      <p className='absolute bottom-0 text-danger' style={{ fontSize: "15px", marginBottom: "0px" }}>
                        {errors?.fecha_ini?.message}
                      </p>
                    </div>
                    <div>
                      <label className='mb-2'>Fecha fin</label>
                      <input className='form-control' type='date' {...register("fecha_fin")} />
                    </div>
                    <Button type='submit'>Consultar</Button>
                  </fieldset>
                </Form>
                <div className='d-none d-sm-block'>
                  <HelperText className='mb-0'>Seleccione un rango de fechas para buscar las actas cargadas por {selectedRow.nombre}.</HelperText>
                  <HelperText className='mb-0'>Si no se selecciona ninguna fecha, se mostraran las actas de los últimos 30 días.</HelperText>
                  <HelperText className='mb-0'>Si se seleccionan fechas iguales, se mostraran todos las actas.</HelperText>
                  <HelperText className='mb-0'>Si se selecciona únicamente "Fecha de inicio", se tendrán en cuenta los 30 días posteriores a la misma, incluida.</HelperText>
                  <HelperText className='mb-0'>Si se selecciona únicamente "Fecha fin", se tendrán en cuenta los 30 dias previos a la misma.</HelperText>
                </div>
              </div>
              <div style={{ borderRadius: "0.375rem" }}>
                <MapaDeCalor data={historialCoordenadasInspector} height='60vh' />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BusquedaMapaCalor;
